import styled from "styled-components"

export const Container = styled.button`
    cursor: pointer;
    display: inline-block;
    text-align: center;
    background-color: var(--gold);
    line-height: normal;
    border: 0;
    color: var(--secondary);
    font: 0.938rem;
    font-weight: 600;
    transition: 0.3s;
    padding: 8px 15px;
    border-radius: 3px;
    height: 50px;
    flex-shrink: 0;
    white-space: nowrap;

    &:hover {
        background-color: var(--gold-light);
    }
`